/** @namespace ShopifyCustomer/Component/LoginFallbackPage/Index/LoginFallbackPage */
export const LoginFallbackPage = () => 'loading login...';

export default LoginFallbackPage;
